import { render, staticRenderFns } from "./FeeChangeLetter.vue?vue&type=template&id=5c42ffad&scoped=true&"
import script from "./FeeChangeLetter.vue?vue&type=script&lang=js&"
export * from "./FeeChangeLetter.vue?vue&type=script&lang=js&"
import style0 from "./FeeChangeLetter.vue?vue&type=style&index=0&id=5c42ffad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42ffad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VProgressLinear,VSpacer})
